import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAccidentInfo, setRouterData, setUserAction } from "../../redux/actions";
import { history } from "../../utils/variables";
import BodyInsurance from "../../assets/images/vehicle-crash-tree2.png"
import ThirdInsurance from "../../assets/images/vehicle-crash2.png"
import CulCar from "../../assets/images/vehicle-crash-cul.png"
import LosCar from "../../assets/images/vehicle-crash-los.png"
import { pexios, toast } from "../../utils/functions";
import Loading from '../../assets/images/gifs/loading.gif'
import Modal from "../../components/master/Modal";
import FreeService from '../../assets/images/free-service.png'
import SpecialService from '../../assets/images/service 1.png'


export default function AccidentType() {
    const [insurance ,setInsurance] = useState('')
    const dispatch = useDispatch();
    const {user,routerData} = useSelector(store => store)
    const [loader,setLoader] = useState(false)
    const [selectService, setSelctService] = useState(true);
    const [free , setFree] = useState(null);
    const [specialModal ,setSpecialModal] = useState(false)
    const specialContent = useRef(null)
    useEffect(()=>{
        if(user.type === 'user') {
            dispatch(setUserAction(''));
            setLoader(true)
            pexios('api/check_old_accident')
            .then((res)=>{
                if(res.data.type){
                    const state = res.data.status;
                    dispatch(setRouterData({...routerData,id: res.data.id, type: 'accident',state:state }));
                    if(state === 0){
                        ///special
                        toast('درخواست قبلی شما در حال بررسی است .در اسرع وقت با شما تماس گرفته خواهد شد . از صبوری شما متشکریم .')
                        history.push(`/`)
                        return;
                    }
                    if(state === 1){
                        ///free
                        history.push(`/user-images`);
                        return;
                    }
                    if(res.data.id) {
                        history.push(`/accident-report`);
                    }
                }
                setLoader(false)
            })
        }
    },[])
    useEffect(()=>{
        function handleClickOutside(e){
            if(specialContent.current && !specialContent.current.contains(e.target)){
                setSpecialModal(false)
            }
        }
        document.addEventListener('mousedown',handleClickOutside)
        return(()=>{
            document.removeEventListener('mousedown',handleClickOutside)
        })
    },[specialContent])

    function claimAccident() {
        dispatch(setRouterData({}));
        if(user.type === 'user') {
        switch(insurance) {
            case 'body':
                dispatch(setAccidentInfo({user_type:'culprit',insurance_type : insurance}))
                history.push('/plans');
                break;
            case 'culprit':
                dispatch(setAccidentInfo({user_type:'culprit',insurance_type : 'third'}))
                history.push('/plans');
                break;
            case 'losses':
                dispatch(setAccidentInfo({user_type:'culprit',insurance_type : 'third'}))
                history.push('/losses-accident');
                break;
            default: break;
        }
        }
        else {
            dispatch(setAccidentInfo({user_type:'culprit',insurance_type : insurance}))
            history.push('/losses-accident');
            // switch(insurance) {
            //     case 'body':
            //         dispatch(setAccidentInfo({user_type:'culprit',insurance_type : insurance}))
            //         history.push('/losses-accident');
            //         break;
            //     // case 'third':
            //     //     dispatch(setAccidentInfo({user_type:'culprit',insurance_type : 'third'}))
            //     //     history.push('/losses-accident');
            //     //     break;
            //     default: 
            //         dispatch(setAccidentInfo({user_type:'culprit',insurance_type : 'third'}))
            //         history.push('/losses-accident');
            //         break;
            // }
        }

    }
    function plansChecking() {
        if(free === true) setSelctService(false)
        // if(free === false) history.push('/get_location')
    }
    
    return (
        <div className="content accident-type">
            <Modal visible={specialModal}>
                <div className='modal-content p10 text-center' ref={specialContent}>
                    <p className='text-justify m20'>ما با قدرت و علاقه در حال بروزرسانی خدمات این صفحه هستیم و به  زودی در دسترس شما قرار خواهد گرفت.</p>
                    <p>ممنون از صبوریتون </p>
                </div>
            </Modal>
            {loader ?
                <Modal visible={loader}>
                    <div className='loader-modal'>
                        <img src={Loading} alt="loader"/>
                    </div>
                </Modal>
             :
             <>
            { selectService ?
            <div className="services">
            <p className='guide-text mx20 mt40'>{user.full_name} عزیز</p>
            <p className='guide-text mt20 mb20 mx20'>
               جهت ثبت درخواست خود میتوانید یکی از روش های زیر را انتخاب و از خدمات آن استفاده نمایید.
           </p>
           <div className="d-flex justify-center">
               <div className={`option ${free === false ? 'active' :''}`} onClick={()=>setSpecialModal(true)}>   
                   <img src={SpecialService} alt="special service"/>
                   <p className='option-title'> خدمات ویژه </p>
               </div>
               <div className={`option ${free === true? 'active' :''}`} onClick={()=>setFree(true)}>   
                   <img src={FreeService} alt="free service"/>
                   <p className='option-title'> خدمات پایه (رایگان) </p>
               </div>
           </div>
           <div className={`plan-option ${free === true && 'selected'}`}>
               {/* <div className='option b-bl-sharp'>   
               خدمات پایه (رایگان)
               <span className='radio-btn' />
               </div> */}
               <div className='plan-desc b-br-sharp'>   
                   <p> + اعلام درخواست </p>
                   <p> + تشکیل پرونده</p> 
                   <p> + ارزیابی تخصصی</p> 
                   <p> + پشتیبانی در تمامی مراحل</p> 
                               
               </div>
           </div>
           <div className={`plan-option pt5 ${free === false && 'selected'}`}>
               {/* <div className='option b-bl-sharp'>   
                خدمات ویژه
               <span className='radio-btn'/>
               </div> */}
               <div className='plan-desc b-br-sharp'>
                   <p> + تمامی خدمات پایه </p>
                   <p> + پشتیبانی 24 ساعته </p>
                   <p> + اختصاص ارزیاب رسمی شخصی</p>
                   <p> + مشاوره جهت تکمیل تمامی مراحل</p>
                   <p> + پیگیری پرداخت خسارت</p>
               </div>
           </div>
           <div className='d-flex justify-center mt20'>
               <button className={`btn btn-circle w-50  ${free !== null ? 'btn-white-purple btn-bold' :'btn-disable'}`} onClick={plansChecking}>ادامه</button>
           </div>
           </div>
            :
            <>
            <p className="insurance-header m10">قصد استفاده از کدام بیمه را دارید؟</p>
            <div className="d-flex justify-center">
                <div className={`insurance-option ${insurance === 'body' ?'active':''}`} onClick={()=>setInsurance('body')}>
                    <img src={BodyInsurance} alt='body'/>
                    <p className="insurance-title">بدنه</p>
                </div>
                <div className={`insurance-option ${(insurance && insurance !== 'body') ?'active':''}`} onClick={()=>setInsurance('third')}>
                    <img src={ThirdInsurance} alt="third"/>
                    <p className="insurance-title">شخص ثالث</p>
                </div>
            </div>
            {(user.type === 'user' && insurance && insurance !== 'body') &&
            <div className="user-type">
            <p className="insurance-header m10"> مقصر هستید یا زیان دیده ؟</p>
            <div className="d-flex justify-center m10">
                <div className={`insurance-option ${insurance === 'losses'? 'active':''}`} onClick={()=>setInsurance('losses')}>
                    <img src={LosCar} alt="car"/><span className="insurance-title">زیان دیده هستم</span>
                </div>
                <div className={`insurance-option ${insurance === 'culprit'? 'active':''}`} onClick={()=>setInsurance('culprit')}>
                    <img src={CulCar} alt="car"/><span className="insurance-title">مقصر هستم</span>
                </div>
            </div>
            </div>
            } 
            <div className='d-flex justify-center mt20'>
                {(user.type === 'user') ?
                <button className={`btn btn-circle w-50  ${(insurance && insurance !== 'third') ? 'btn-white-purple btn-bold' :'btn-disable'}`} onClick={claimAccident}>ادامه</button>
                :
                <button className={`btn btn-circle w-50  ${insurance ? 'btn-white-purple btn-bold' :'btn-disable'}`} onClick={claimAccident}>ادامه</button>
            }
            </div>
            </>
            }
            </>
            }
        </div>
    );
}